import React, {Component} from 'react';
import {board, swap} from '../../helpers/exportConsts';
import './Gameboard.scss';

class Gameboard extends Component{
  constructor(props) {
    super(props);
    this.state = {
      arr: new Array(9).fill(1).map((_, i) => i + 1),
      swapCount: 0,
      colorIndexing: new Array(9).fill('rgba(0, 0, 0, 0.341176)')
    }
  }

  render() {
    const {arr, changeGameState, checkArr} = this.props;
    const swapOp = (copy_arr, sd, sy) => {
      const arr = Array.from(copy_arr);
      const colorIndexing = new Array(9).fill('rgba(0, 0, 0, 0.341176)');
      const swapCount = this.state.swapCount + 1;
      swap(arr, sd, sy, colorIndexing);
      this.setState({...this.state, arr, swapCount, colorIndexing});
      if(JSON.stringify(arr) === checkArr)
        changeGameState("gameOff", swapCount);
    };

    return(
      <div className={'gameboard py-5'}>
        <div className={'main'}>
          <div>
            <div className="swap-counter px-3 py-3 mb-3">
              Swaps performed: {this.state.swapCount}
            </div>
            <div className="row even px-5">
              <button className={'action swap-btn px-3 py-3 mr-5'} onClick={() =>
                swapOp(this.state.arr, 1, 0)}/>
              <button className={'action swap-btn px-3 py-3'} onClick={() =>
                swapOp(this.state.arr, 1, 1)}/>
            </div>
            <div className="row">
              <div className={'row flex-column even'}>
                <button className={'action rt swap-btn px-3 py-3'} onClick={() =>
                  swapOp(this.state.arr, 0, 0)}/>
                <button className={'action rt swap-btn px-3 py-3'} onClick={() =>
                  swapOp(this.state.arr, 0, 3)}/>
              </div>
              <div className={'mt-3 mb-2 mr-3 ml-2'}>
                {board(arr, this.state.arr, this.state.colorIndexing)}
              </div>
              <div className={'row flex-column even'}>
                <button className={'action rt swap-btn px-3 py-3'} onClick={() =>
                  swapOp(this.state.arr, 0, 1)}/>
                <button className={'action rt swap-btn px-3 py-3'} onClick={() =>
                  swapOp(this.state.arr, 0, 4)}/>
              </div>
            </div>
            <div className="row even px-5">
              <button className={'action swap-btn px-3 py-3 mr-5'} onClick={() =>
                swapOp(this.state.arr, 1, 3)}/>
              <button className={'action swap-btn px-3 py-3'} onClick={() =>
                swapOp(this.state.arr, 1, 4)}/>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default Gameboard;